import React, { useEffect } from 'react';
import {
    Row,
    Col,
    Spin,
    Empty,
} from 'antd';
import { useSelector, useDispatch } from "react-redux";
import { Bar, Line as LineChart } from "react-chartjs-2";
import {
    taskActions
} from "../../../../redux/_actions";


const ChartGlobale = ({ data, tada, setChooseTeam }) => {

    const profil_chef_projet = 2;

    const dispatch = useDispatch();
    const loading_chart = useSelector((state) => state.task.loading_chart);
    const equipes = useSelector((state) => state.team.items);
    const filter_chart = useSelector((state) => state.task.filter_chart);
    const user_login_profil = useSelector((state) => state.login.item.id_profil);
    const user_login = useSelector((state) => state.login);

    const optionsGrouped = {
        maintainAspectRatio: false,
        scales: {
            yAxes: [
                {
                    ticks: {
                        beginAtZero: true,
                    },
                },
            ],
        },

        onClick: function (evt, element) {
            if (element.length > 0) {
                var choixEquipe;
                if (user_login_profil !== profil_chef_projet) {
                    choixEquipe = equipes.filter((p) => p.libelle === data.labels[element[0].index])[0];
                } else {
                    choixEquipe = equipes.filter((p) => p.libelle === data.labels[0])[0];
                }
                setChooseTeam(choixEquipe);
                // Tabs Projets 
                dispatch(taskActions.getChartEAProjets({
                    id_equipe: choixEquipe.id_equipe,
                    date_debut: filter_chart.length > 0 ? filter_chart[0] : null,
                    date_fin: filter_chart.length > 0 ? filter_chart[1] : null,
                }));
                dispatch(taskActions.getChartCHUsers({
                    id_equipe: choixEquipe.id_equipe,
                    date_debut: filter_chart.length > 0 ? filter_chart[0] : null,
                    date_fin: filter_chart.length > 0 ? filter_chart[1] : null,
                }));
                // Tabs Equipes/Usres
                dispatch(taskActions.getDataChartEquipe({
                    id_equipe: choixEquipe.id_equipe,
                    date_debut: filter_chart.length > 0 ? filter_chart[0] : null,
                    date_fin: filter_chart.length > 0 ? filter_chart[1] : null,
                }));
                dispatch(taskActions.getDataChartUsers({
                    id_equipe: choixEquipe.id_equipe,
                    date_debut: filter_chart.length > 0 ? filter_chart[0] : null,
                    date_fin: filter_chart.length > 0 ? filter_chart[1] : null,
                }));
            }
        },
    }

    const optionsStacked = {
        maintainAspectRatio: false,
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true
            }
        },
        onClick: function (evt, element) {
            if (element.length > 0) {
                var choixEquipe;
                if (user_login_profil !== profil_chef_projet) {
                    choixEquipe = equipes.filter((p) => p.libelle === data.labels[element[0].index])[0];
                } else {
                    choixEquipe = equipes.filter((p) => p.libelle === data.labels[0])[0];
                }
                setChooseTeam(choixEquipe);
                // Tabs Projets 
                dispatch(taskActions.getChartEAProjets({
                    id_equipe: choixEquipe.id_equipe,
                    date_debut: filter_chart.length > 0 ? filter_chart[0] : null,
                    date_fin: filter_chart.length > 0 ? filter_chart[1] : null,
                }));
                dispatch(taskActions.getChartCHUsers({
                    id_equipe: choixEquipe.id_equipe,
                    date_debut: filter_chart.length > 0 ? filter_chart[0] : null,
                    date_fin: filter_chart.length > 0 ? filter_chart[1] : null,
                }));
                // Tabs Equipes/Usres
                dispatch(taskActions.getDataChartEquipe({
                    id_equipe: choixEquipe.id_equipe,
                    date_debut: filter_chart.length > 0 ? filter_chart[0] : null,
                    date_fin: filter_chart.length > 0 ? filter_chart[1] : null,
                }));
                dispatch(taskActions.getDataChartUsers({
                    id_equipe: choixEquipe.id_equipe,
                    date_debut: filter_chart.length > 0 ? filter_chart[0] : null,
                    date_fin: filter_chart.length > 0 ? filter_chart[1] : null,
                }));
            }
        },
    }

    useEffect(() => {
        if (user_login_profil === profil_chef_projet) {
            let choixEquipe = equipes.filter((p) => p.libelle === user_login.item.libelle_equipe)[0];
            setChooseTeam(choixEquipe);
            // console.log('valLog', choixEquipe)

            dispatch(taskActions.getChartEAProjets({
                id_equipe: choixEquipe.id_equipe,
                date_debut: filter_chart.length > 0 ? filter_chart[0] : null,
                date_fin: filter_chart.length > 0 ? filter_chart[1] : null,
            }));
            dispatch(taskActions.getChartCHUsers({
                id_equipe: choixEquipe.id_equipe,
                date_debut: filter_chart.length > 0 ? filter_chart[0] : null,
                date_fin: filter_chart.length > 0 ? filter_chart[1] : null,
            }));
            // Tabs Equipes/Usres
            dispatch(taskActions.getDataChartEquipe({
                id_equipe: choixEquipe.id_equipe,
                date_debut: filter_chart.length > 0 ? filter_chart[0] : null,
                date_fin: filter_chart.length > 0 ? filter_chart[1] : null,
            }));
            dispatch(taskActions.getDataChartUsers({
                id_equipe: choixEquipe.id_equipe,
                date_debut: filter_chart.length > 0 ? filter_chart[0] : null,
                date_fin: filter_chart.length > 0 ? filter_chart[1] : null,
            }));
        }
    });

    return (
        <>
            <Row>
                <Col span={12}>
                    <Spin
                        tip="Chargement en cours..."
                        size="large"
                        spinning={loading_chart}
                    >
                        <h3 style={{ textAlign: 'center' }}>L'ENSEMBLE DES TACHES PAR ÉQUIPES</h3>
                        <div style={{ marginLeft: 5, marginRight: 15 }}>
                            {Object.keys(data).length > 0 ? (
                                <Bar
                                    height={380}
                                    data={data}
                                    options={optionsGrouped}
                                    style={{
                                        cursor: 'pointer'
                                    }}
                                />
                            ) : (
                                <>
                                    <Empty description={false} />
                                </>
                            )}
                        </div>
                    </Spin>
                </Col>
                <Col span={12}>
                    <Spin
                        tip="Chargement en cours..."
                        size="large"
                        spinning={loading_chart}
                    >
                        <h3 style={{ textAlign: 'center' }}>L'ENSEMBLE DES TACHES DES ÉQUIPES PAR TYPE DE TACHE</h3>
                        <div style={{ marginLeft: 15, marginRight: 15 }}>
                            {Object.keys(tada).length > 0 ? (
                                <Bar
                                    height={380}
                                    data={tada}
                                    options={optionsStacked}
                                    style={{
                                        cursor: 'pointer'
                                    }}
                                />
                            ) : (
                                <>
                                    <Empty description={false} />
                                </>
                            )}
                        </div>
                    </Spin>
                </Col>
            </Row>
        </>
    )
}

export default ChartGlobale;